module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-instructions-for-use@3x.f9c9bbcd.jpg";